// Some WebViews throw just for touching `window.localStorage`, so the playlist service only reaches it through here.
export const getLocalStorage = () => {
    try {
        return window.localStorage || null;
    } catch (e) {
        return null;
    }
};
